import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, OnInit, Renderer2, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { Router } from '@angular/router';
import { Observable, Subject, of } from 'rxjs';
import { catchError, map, switchMap, takeUntil, tap } from 'rxjs/operators';
import { notificationStatus, notificationTemplateStatusV2, notificationsTemplateStatusV2 } from 'src/app/_enums';
import { AppConfig, DataService } from 'src/app/_helpers';
import { Configuration } from 'src/app/_models';
import { ConfigurationService, CustomerService } from 'src/app/_services';
import { bluePlusIcon, copyIcon, dotsVerticalIcon, editFirstVersionIcon, editIcon, filterLinesIcon, searchIcon } from 'src/app/sharedcomp/constans/icons.constans';

@Component({
  selector: 'app-notification-schedule',
  templateUrl: './notification-schedule.component.html',
  styleUrls: [
    './notification-schedule.component.css',
    '../../../../../assets/css/new-component-view.css',
    '../../../../../assets/css/new-badges-chips-theme.css',
    '../../../../../assets/css/new-form-elements.css',
    '../../../../../assets/css/new-buttons-theme.css',
    '../../../../sharedcomp/sidebar/sidebar.component.css',
    '../../../../sharedcomp/ui-components/drpdowns/dropdown/dropdown.component.css'
  ],
  animations: [
    trigger('animationSplit', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateX(400px)' }),
        animate('500ms ease-out', style({ opacity: 1, transform: 'translateX(0)' })),
      ]),
      transition(':leave', [
        animate('500ms ease-in', style({ opacity: 1, transform: 'translateX(500px)' })),
      ]),
    ]),
    trigger('fadeInOut', [
      state('void', style({ opacity: 0 })),
      transition(':enter', [
        animate(200, style({ opacity: 1 })),
      ]),
    ])
  ]
})
export class NotificationScheduleComponent implements OnInit {

  icons: Record<string, { path: string; alt: string }>;

  displayLoaderSpinner: boolean = false;
  dataSource: MatTableDataSource<any> = new MatTableDataSource([]);
  templateList: any[];
  notificationList$: Observable<any>;
  displayedColumns: string[] = ['data', 'template', 'status', 'actions'];
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  pageSize: number;
  PageSizeOptions: number[];
  totalSize: number = 0;

  searchFilterForm: FormGroup;
  notificationStatusSelectedValue: notificationTemplateStatusV2 | 'TODOS' = 'TODOS';
  status: string = "All";
  ddlnotificationStatus: (typeof notificationsTemplateStatusV2);
  notificationList = [];
  public custNotifyTemplateList: any[];
  public custNotifyFilterTemplateList: any[];
  templateListLimit: number = 100;

  private customerPublicId: string;

  public notificationEditForm: FormGroup;
  notificationPublicId: string;
  selectorValue: string;

  isCreateNotificationSidebarVisible: boolean;
  isEditNotificationSidebarVisible: boolean;

  private destroy$ = new Subject<void>();

  constructor(
    private formBuilder: FormBuilder,
    private configurationService: ConfigurationService,
    private router: Router,
    private _notificationStatus: notificationStatus,
    private dataService: DataService,
    private customerService: CustomerService,
    private renderer: Renderer2
  ) {
    this.initSearchForm();
    this.initNotificationEditForm();
    this.icons = this.setIcons();
    this.pageSize = AppConfig.settings.gridPageSetting.PageSize;
    this.PageSizeOptions = AppConfig.settings.gridPageSetting.PageSizeOptions;
    this.ddlnotificationStatus = notificationsTemplateStatusV2;
  }

  ngOnInit() {
    let browserStorage1 = (localStorage.getItem('isCorporate') == 'undefined') ? null : localStorage;
    if (browserStorage1 == null) {
      let browserStorage = localStorage.getItem('companyId');
      if (browserStorage == null || browserStorage == '' || browserStorage == undefined) {
        this.router.navigate(['/home']);
      } else {
        this.customerPublicId = localStorage.getItem('companyId');
      }
    } else {
      this.customerPublicId = localStorage.getItem('subcompanyId');
    }

    this.paginator._intl.itemsPerPageLabel = "Registros por página";
    this.paginator._intl.nextPageLabel = "siguiente página";
    this.paginator._intl.lastPageLabel = "última página";
    this.paginator._intl.previousPageLabel = "anterior página";
    this.paginator._intl.firstPageLabel = "primera página";
    this.dataSource.paginator = this.paginator;
    this.getCustomerNotificationTemplateList();
    this.getNotificationList();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getNotificationListAfterCreation(getList: boolean) {
    if (getList) {
      this.displayLoaderSpinner = true;
      this.notificationList$.subscribe();
    }
  }

  getNotificationListAfterEdition(getList: boolean) {
    if (getList) {
      this.displayLoaderSpinner = true;
      this.notificationList$.subscribe();
    }
  }

  cancelCreation(cancel: boolean) {
    if (!cancel) {
      this.isCreateNotificationSidebarVisible = cancel;
      this.renderer.removeClass(document.body, 'modal-open');
    }
  }

  cancelEdition(cancel: boolean) {
    if (!cancel) {
      this.isEditNotificationSidebarVisible = cancel;
      this.renderer.removeClass(document.body, 'modal-open');
    }
  }

  openCreateNotificationSidebar() {
    this.renderer.addClass(document.body, 'modal-open');
    this.isCreateNotificationSidebarVisible = true;
  }

  openEditNotificationSidebar(publicId: string) {
    this.notificationPublicId = publicId;
    this.renderer.addClass(document.body, 'modal-open');
    this.isEditNotificationSidebarVisible = true;
  }

  initNotificationEditForm() {
    this.notificationEditForm = this.formBuilder.group({
      id: new FormControl(""),
      name: new FormControl("", Validators.required),
      description: new FormControl("", Validators.required),
      status: new FormControl("Activo"),
      object: new FormControl(""),
      object_related: new FormControl("INVOICE"),
      public_id: new FormControl(""),
      type: new FormControl("NOTIFICATION"),
      values: this.formBuilder.group({
        days: new FormControl(0, [Validators.required, Validators.min(0), Validators.max(180)]),
        hours: new FormControl(0, [Validators.required, Validators.min(0), Validators.max(23)]),
        minutes: new FormControl(0, [Validators.required, Validators.min(0), Validators.max(59)]),
        selector: new FormControl("1"),
        template_id: new FormControl("", Validators.required)
      })
    });
  }

  setNewStatus(type: 'ACTIVE' | 'INACTIVE') {
    return type === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE';
  }

  onCheckboxClick(event, element) {
    event.preventDefault();
    this.dataService.loadSpinner(true);
    const newStatus = this.setNewStatus(element.status);
    this.updateNotificationProcess$(element, newStatus)
      .pipe(
        takeUntil(this.destroy$),
        tap(data => {
          if (data != null) {
            element.status = data.status;
          }
          this.dataService.loadSpinner(false);
        })
      ).subscribe();
  }

  updateNotificationProcess$(element, newStatus) {
    this.notificationEditForm.reset();
    const notificationPublicId = element.public_id;
    return this.configurationService.getConfiguration(notificationPublicId)
      .pipe(
        takeUntil(this.destroy$),
        tap((data: Configuration) => {
          if (data.values.selector == undefined) {
            if (data.values.days >= 0) {
              this.selectorValue = "2"
            }
            if (data.values.days < 0) {
              this.selectorValue = "1"
            }
          } else {
            this.selectorValue = data.values.selector;
          }

          this.notificationEditForm.patchValue({
            id: data.id,
            name: data.name,
            description: data.description,
            status: newStatus,
            object: data.object,
            object_related: data.object_related,
            public_id: data.public_id,
            type: data.type,
            values: {
              days: Math.abs(data.values.days),
              hours: data.values.hours,
              minutes: data.values.minutes,
              template_id: data.values.template_id,
              selector: this.selectorValue
            }
          });
        }),
        switchMap((data: Configuration) => this.updateNotificationStatus$(notificationPublicId, this.notificationEditForm)),
        catchError(error => {
          console.error('Failed while trying to get notification detail.' + error);
          this.dataService.loadSpinner(false);
          return of(null);
        })
      )
  }

  updateNotificationStatus$(notificationPublicId, { value }: { value: Configuration }) {
    return this.configurationService.updateConfiguration(value, notificationPublicId)
      .pipe(
        takeUntil(this.destroy$),
        catchError(error => {
          console.error('Failed while trying to update notification template detail.' + error);
          this.dataService.loadSpinner(false);
          return of(null);
        })
      )
  }

  getCustomerNotificationTemplateList() {
    this.customerService.getCustomerNotificationTemplateList(this.customerPublicId, this.templateListLimit)
      .pipe(
        takeUntil(this.destroy$)
      )
      .subscribe(data => {
        if (data && Array.isArray(data)) {
          this.custNotifyTemplateList = data;
          this.custNotifyFilterTemplateList = this.custNotifyTemplateList;
        } else {
          this.custNotifyTemplateList = [];
          this.custNotifyFilterTemplateList = [];
        }
      }, error => {
        this.custNotifyTemplateList = [];
        this.custNotifyFilterTemplateList = [];
      });
  }

  getNotificationList() {
    this.displayLoaderSpinner = true;
    this.dataService.loadSpinner(true);
    this.notificationList$ = this.configurationService.getConfigurationList(this.customerPublicId, "INVOICE", "NOTIFICATION")
      .pipe(
        takeUntil(this.destroy$),
        tap(data => {
          let resources = data["data"];
          this.dataSource.data = resources;
          this.notificationList = resources;
          this.totalSize = resources.length;
          this.displayLoaderSpinner = false;
          this.dataService.loadSpinner(false);
        }),
        catchError(err => {
          console.error('Failed while trying to get customer notification template list. ' + err);
          this.dataService.loadSpinner(false);
          this.displayLoaderSpinner = false;
          return of(null)
        })
      )
  }

  filter() {
    let tempFilterData = this.notificationList;
    if (this.status != "All") {
      tempFilterData = tempFilterData.filter(data => data.status == this.status)
    }

    if (this.searchFilterForm.controls.searchTextFormControl.value.length > 0) {
      var serachValue = this.searchFilterForm.controls.searchTextFormControl.value.trim();
      tempFilterData = tempFilterData.filter(data => data.name.toLowerCase().includes(serachValue.toLowerCase()))
    }

    this.dataSource.data = tempFilterData;
    this.paginator.firstPage();
  }

  filterStatusDetails(status) {
    if (status == 'TODOS') {
      this.status = "All"
    } else {
      this.status = status;
    }
    this.filter();
  }

  selectStatusOption(option: notificationTemplateStatusV2["value"] | 'TODOS') {
    const filteredNotificationByType = this.ddlnotificationStatus.filter(el => el.value === option);
    this.notificationStatusSelectedValue = filteredNotificationByType.length > 0 ? filteredNotificationByType[0] : 'TODOS';
    this.filterStatusDetails(option);
  }

  setIcons() {
    return {
      bluePlus: bluePlusIcon,
      searchIcon: searchIcon,
      filterLines: filterLinesIcon,
      dotsVertical: dotsVerticalIcon,
      edit: editIcon,
      copy: copyIcon,
      editIcon2: editFirstVersionIcon
    };
  }

  applyFilter() {
    this.filter();
  }

  getTemplateName(idValue) {
    if (this.custNotifyTemplateList === undefined) {
      return "";
    } else {
      this.custNotifyFilterTemplateList = this.custNotifyTemplateList.filter(t => (t === 'undefined') ? "" : t);
      this.custNotifyFilterTemplateList = this.custNotifyTemplateList.filter(t => t.public_id == idValue);
      if (this.custNotifyFilterTemplateList.length == 1 && this.custNotifyTemplateList[0] !== undefined && this.custNotifyTemplateList[0] != null) {
        return this.custNotifyFilterTemplateList[0].name;
      }
      return "";
    }
  }

  initSearchForm() {
    this.searchFilterForm = this.formBuilder.group({
      searchTextFormControl: ['']
    });
  }

}
